<div class="card-wrap">
    <div class="card-inner">
  
      <div class="brand">
        <span class="brand-k">K</span><span class="brand-rest">onvac</span>
      </div>
      <p class="tagline">Sign in to your account</p>
  
      <div class="info-banner">
        <svg class="info-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
        <span>
          This is a research preview. Please
          <a href="mailto:vasalchahat@gmail.com" class="reach-link">reach out to us</a>
          to get access.
        </span>
      </div>
  
      <form (ngSubmit)="onSubmit()" #loginForm="ngForm" novalidate autocomplete="off">
  
        <div class="field-group">
          <label for="email" class="field-label">Email</label>
          <div class="input-wrap">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            <input id="email" type="email" class="field-input" placeholder="you@example.com"
                   [(ngModel)]="email" name="email" required email autocomplete="email"/>
          </div>
        </div>
  
        <div class="field-group">
          <div class="label-row">
            <label for="password" class="field-label">Password</label>
            <!-- Forgot password link -->
            <button type="button" class="forgot-link" (click)="onForgotPassword()">
              Forgot password?
            </button>
          </div>
          <div class="input-wrap">
            <svg class="input-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
            <input id="password" [type]="showPassword ? 'text' : 'password'" class="field-input"
                   placeholder="••••••••" [(ngModel)]="password" name="password" required
                   autocomplete="current-password"/>
            <button type="button" class="toggle-pw" (click)="togglePassword()"
                    [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                <circle cx="12" cy="12" r="3"/>
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                <line x1="1" y1="1" x2="23" y2="23"/>
              </svg>
            </button>
          </div>
        </div>
  
        <p class="error-msg" *ngIf="errorMessage">{{ errorMessage }}</p>
  
        <button type="submit" class="login-btn" [class.loading]="loading" [disabled]="!isFormValid || loading">
          <span class="btn-text" *ngIf="!loading">Log in</span>
          <span class="spinner" *ngIf="loading">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
              <circle cx="12" cy="12" r="10" stroke-opacity=".25"/>
              <path d="M12 2a10 10 0 0 1 10 10" class="spin-arc"/>
            </svg>
          </span>
        </button>
  
      </form>
    </div>
  </div>